import React from 'react'
import { Form } from 'react-bootstrap'
import { FormData } from './RegisterForm'

interface Step2Props {
  formData: FormData
  updateFormData: (field: keyof FormData, value: string | boolean) => void
  errors: {
    agentCode: string
    name: string
    email: string
    trueInfoConsent: string
    consent: string
  }
  onSubmit: (e: React.FormEvent) => void
}

export default function Step2({ formData, updateFormData, errors, onSubmit }: Step2Props) {
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData('name', e.target.value)
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData('email', e.target.value)
  }

  const handleConsentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData('consent', e.target.checked)
  }

  const handleTrueInfoConsentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData('trueInfoConsent', e.target.checked)
  }

  return (
    <>
      <h1>RSVP NOW to the Principal 2026 Q2 Agency Rolldown Virtual Event</h1>
      <p className="muted">Please provide your details to complete the registration</p>
      <Form className="form d-flex flex-column justify-content-center align-items-center" onSubmit={onSubmit}>
        <Form.Row style={{ gap: '1rem', marginBottom: '20px' }}>
          <Form.Group className="input-mobile-fix">
            <Form.Label>Name</Form.Label>
            <Form.Control
              className={`w-full min-w-400px form-input ${errors.name ? 'is-invalid' : ''}`}
              type="text"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleNameChange}
              required
            />
            {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
          </Form.Group>
          <Form.Group className="input-mobile-fix">
            <Form.Label>
              Email <span style={{ fontWeight: 500, fontSize: '14px' }}>(Event passcode will be sent to the registered email)</span>
            </Form.Label>
            <Form.Control
              className={`min-w-400px form-input ${errors.email ? 'is-invalid' : ''}`}
              type="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleEmailChange}
              required
            />
            {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
          </Form.Group>
        </Form.Row>
        <div className="align-self-start">
          <Form.Check
            type="checkbox"
            id="correct-info-checkbox"
            checked={formData.trueInfoConsent}
            onChange={handleTrueInfoConsentChange}
            className={errors.trueInfoConsent ? 'is-invalid' : ''}
            required
            label={
              <p style={{ fontWeight: 'normal', fontSize: '14px' }}>
                I agree that all information provided is true, accurate, not misleading, and that it does not omit any material fact.
              </p>
            }
          />
          {errors.trueInfoConsent && <div className="invalid-feedback d-block">{errors.trueInfoConsent}</div>}
        </div>
        <div style={{ maxWidth: '854px' }}>
          <Form.Check
            type="checkbox"
            id="consent-checkbox"
            checked={formData.consent}
            onChange={handleConsentChange}
            className={errors.consent ? 'is-invalid' : ''}
            required
            label={
              <p style={{ fontWeight: 'normal', fontSize: '14px' }}>
                <b>Consent for Collection and Use of Personal Data.</b>
                <br />
                By ticking this box, I agree and consent to the collection and use of my personal data (including my name and email address) by Principal Asset
                Management Berhad for the purpose of registering and communicating with me regarding Principal 2026 Q2 Agency Rolldown virtual event only. My
                personal data will be used solely for event-related updates and will not be shared with third parties unrelated to this event.
              </p>
            }
          />
          {errors.consent && <div className="invalid-feedback d-block">{errors.consent}</div>}
        </div>
      </Form>
    </>
  )
}
